import { ReactNode, useId } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import type { PlacesType } from "react-tooltip";

interface TooltipProps {
  content: ReactNode;
  place?: PlacesType;
  children: ReactNode;
}

/** Hover tooltip anchored to its children (replacement for react-tippy). */
function Tooltip({ content, place = "top", children }: TooltipProps) {
  const id = useId();

  return (
    <>
      <div data-tooltip-id={id} style={{ display: "inline" }}>
        {children}
      </div>
      <ReactTooltip
        id={id}
        place={place}
        positionStrategy="fixed"
        className="z-50"
      >
        {content}
      </ReactTooltip>
    </>
  );
}

export default Tooltip;
